var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#9FA5AC",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 5.5,
    height: 5.5,
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7.5,
    width: 5.5,
    height: 5.5,
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 6.5,
    width: 5.5,
    height: 5.5,
    rx: 1.5,
    transform: "rotate(-90 7.5 6.5)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 5.5,
    height: 5.5,
    rx: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.5b57e9da42a32bf29db37bed3e693d30.svg";
export { ForwardRef as ReactComponent };